// Single source of truth for Sentry env vars in this repo.
// Read VITE_SENTRY_* here, nowhere else.

export interface SentryEnv {
  dsn: string;
  environment: string;
  release: string | undefined;
}

const PLACEHOLDER_RE = /^(?:<.*>|.*_replace_me)$/;

function cleanEnvValue(value: string | undefined): string | null {
  const cleaned = value?.trim();
  if (!cleaned || PLACEHOLDER_RE.test(cleaned)) {
    return null;
  }
  return cleaned;
}

/** Reads the optional Sentry browser configuration from Vite env. */
export function getSentryEnv(): SentryEnv | null {
  const dsn = cleanEnvValue(import.meta.env.VITE_SENTRY_DSN);
  if (!dsn) {
    return null;
  }

  return {
    dsn,
    environment: import.meta.env.MODE,
    release: cleanEnvValue(import.meta.env.VITE_APP_VERSION) ?? undefined,
  };
}
